import React, { useEffect, useState } from 'react';
import './BatteryDetails.css';
import jsPDF from "jspdf";
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
const BatteryDetails = () => {
    const [label, setLabel] = useState(null);

    useEffect(() => {
        // Retrieve the label from localStorage
        const storedLabel = localStorage.getItem('batteryBackupLabel');
        if (storedLabel) {
            setLabel(storedLabel); // Store the label in state
        } else {
            console.error('No label found in localStorage');
        }
    }, []);

    if (!label) {
        return <p>Loading data...</p>; // Show loading until the label is retrieved
    }

    // console.log(label); // Log the label to check if it's correctly retrieved
    const tableData = [
        { district: 'District 1', subdivision: 'Subdivision A', block: 'Block 1', panchayat: 'Panchayat 1', fpsId: '123', ownerName: 'Owner 1', dateOfInspection: '2025-02-01', inspectionOfficer: 'Officer 1' },
        { district: 'District 2', subdivision: 'Subdivision B', block: 'Block 2', panchayat: 'Panchayat 2', fpsId: '124', ownerName: 'Owner 2', dateOfInspection: '2025-02-02', inspectionOfficer: 'Officer 2' },
        // Add more rows as needed
    ];
    // Define messages based on the label
    const getBackupMessage = (label) => {
        switch (label) {
            case '0-1 Hrs':
                return 'ePOS Battery Backup Below 1 hour';
            case '1-2 Hrs':
                return 'ePOS Battery Backup Between 1 - 2 hours';
            case '2-3 Hrs':
                return 'ePOS Battery Backup Between 2 - 3 hours';
            case '3-4 Hrs':
                return 'ePOS Battery Backup Above 3 hours';
            default:
                return 'No data available'; // Fallback message if label is unknown
        }
    };

    // Get the backup message for the selected label
    const backupMessage = getBackupMessage(label);
    // Function to generate PDF
    const generatePDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9, 1, 193, 36);  // Image format: 'PNG'
        doc.setFontSize(18);

        doc.text("Battery Backup Details", 70, 40);
        doc.text(backupMessage, 10, 50);
        let currentYPosition = 53;
        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, 200, currentYPosition + 3, { align: 'right' });
        currentYPosition += 5;


        let currentXPosition = 80;
        const headers = ['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'FpsId', 'Owner Name', 'Date of Inspection', 'Inspection Officer'];

        const tableRows = tableData.map((data, index) => [
            index + 1,
            (data.district || 'N/A'),
            (data.subdivision || 'N/A'),
            (data.block || 'N/A'),
            (data.panchayat.trim() || 'N/A'),
            data.fpsId || 'N/A',
            (data.ownerName || 'N/A'),
            (new Date(data.dateOfInspection), 'dd-MM-yyyy'),
            (data.inspectionOfficer || 'N/A'),
        ]);
        doc.autoTable({
            head: [headers],
            body: tableRows,
            startY: currentYPosition,
            startX: currentXPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No - Center alignment
                1: { cellWidth: 20, halign: 'left' },    // District - Left alignment
                2: { cellWidth: 23, halign: 'left' },    // Subdivision - Left alignment
                3: { cellWidth: 20, halign: 'left' },    // Block Name - Left alignment
                4: { cellWidth: 25, halign: 'left' },    // Panchayat Name - Left alignment
                5: { cellWidth: 20, halign: 'right' },   // FPS ID - Right alignment
                6: { cellWidth: 20, halign: 'left' },   // Start Time - Right alignment
                7: { cellWidth: 25, halign: 'right' },    // POIMS User - Left alignment
                8: { cellWidth: 25, halign: 'left' },

            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 10,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });
        doc.save('battery-backup-details.pdf'); // Save the PDF
    };


    const generateXLSX = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Battery Backup Details');

        // Title Row
        worksheet.mergeCells('A1:I1');
        worksheet.getCell('A1').value = 'Battery Backup Details';
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };

        // Message Row
        worksheet.mergeCells('A2:I2');
        worksheet.getCell('A2').value = backupMessage;
        worksheet.getCell('A2').alignment = { horizontal: 'center' };
        worksheet.getCell('A2').font = { size: 12, italic: true, color: { argb: 'F7912B' } };
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // Message Row
        worksheet.mergeCells('A3:I3');
        worksheet.getCell('A3').value = `Report Date : ${formattedDateTime}`;
        worksheet.getCell('A3').alignment = { horizontal: 'right' };
        worksheet.getCell('A3').font = { size: 11, italic: true, color: { argb: '00000' } };
        // Headers
        const headers = ['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'FpsId', 'Owner Name', 'Date of Inspection', 'Inspection Officer'];
        worksheet.addRow(headers);


        // Format the header row
        const headerRow = worksheet.getRow(4); // Row index 3 (4th row) since row 1 and 2 are used
        headerRow.font = { size: 12, bold: true };
        headerRow.alignment = { horizontal: 'center' };

        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFA500' } // Orange color (hex: #FFA500)
            }
        });
        worksheet.getRow(4).eachCell((cell) => {

            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }

            };
        });
        // Insert Table Data
        tableData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,  // S.No
                data.district || 'N/A',
                data.subdivision || 'N/A',
                data.block || 'N/A',
                data.panchayat.trim() || 'N/A',
                data.fpsId || 'N/A',
                data.ownerName || 'N/A',
                (new Date(data.dateOfInspection)).toLocaleDateString('en-GB'), // Format date as dd-MM-yyyy
                data.inspectionOfficer || 'N/A'
            ]);

            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // Column 0 (S.No)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 6 || colNumber === 8) {  // Columns 6 (fpsId) and 7 (startTime)
                    cell.alignment = { horizontal: 'right' };  // Right align for fpsId and startTime
                } else {
                    cell.alignment = { horizontal: 'left' };  // Left align for all other columns
                }
            });

        });



        // Auto-size the columns based on content
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const value = cell.value ? cell.value.toString() : '';
                maxLength = Math.max(maxLength, value.length);
            });
            column.width = maxLength + 2; // Add padding
        });

        // Export to XLSX file
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'battery-backup-details.xlsx';
            link.click();
        }).catch((err) => {
            console.error('Error generating XLSX file:', err);
        });
    };



    return (
        <div className="Battery-1">
            <div className="Battery-repo">
                <div className="Battery-header-15">
                    <button className="Battery-btn" onClick={generatePDF}>
                        DOWNLOAD PDF
                    </button>
                    <button className="Battery-btn" onClick={generateXLSX}>
                        DOWNLOAD XLSX
                    </button>
                </div>
                <div className='batteryDetails-1 '>
                    <h2>{backupMessage}</h2>
                </div>
                {/* Display the battery backup message above the table */}


                {/* Table data (mock data as you provided earlier) */}
                <table className="Battery-table-home">
                    <thead className="Battery-head-home">
                        <tr>
                            <th>S.No</th>
                            <th>District</th>
                            <th>Subdivision</th>
                            <th>Block</th>
                            <th>Panchayat</th>
                            <th>FpsId</th>
                            <th>Owner Name</th>
                            <th>Date of Inspection</th>
                            <th>Inspection Officer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Mock data for the table */}
                        {tableData.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.district}</td>
                                <td>{item.subdivision}</td>
                                <td>{item.block}</td>
                                <td>{item.panchayat}</td>
                                <td>{item.fpsId}</td>
                                <td>{item.ownerName}</td>
                                <td>{item.dateOfInspection}</td>
                                <td>{item.inspectionOfficer}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BatteryDetails;
